module.exports = __webpack_public_path__ + "static/media/contraction1_img.3ddec51a.JPG";